import Layout from '@layout/Index'

export const platformAndroidapkTest = [
  {
    path: '/platform-androidapk-test',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "platform-androidapk-test-table" */ './pages/PlatformAndroidapkTestTable.vue'),
        name: '安卓APK发布列表',
        meta: {
          title: '安卓APK发布列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "platform-androidapk-test-form" */ './pages/PlatformAndroidapkTestForm.vue'),
        name: '添加安卓APK',
        meta: {
          title: '添加安卓APK',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "platform-androidapk-test-form" */ './pages/PlatformAndroidapkTestForm.vue'),
        name: '修改安卓APK',
        meta: {
          title: '修改安卓APK',
        },
      }
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/platform-androidapk-test/platform-androidapk-test.route.js